import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { Helmet } from "react-helmet";
import queryString from "query-string";

const CanonicalPagination = props => {
  const trailingSlashRegex = /\/$/;
  const [paginationInfo, setPaginationInfo] = useState({});
  useEffect(() => {
    setPaginationInfo(props.pagination);
  }, [props.pagination?.current_page]);

  const getVendorsPrevLink = () => {
    let currentURL;
    if (props.location.search) {
      currentURL = `${props.location.pathname.replace(trailingSlashRegex, "")}${
        props.location.search
      }`;
      const qString = queryString.parse(props.location.search);
      if (Number(qString.p) === 2) {
        currentURL = currentURL.replace(/p=\d+/, "");
        return currentURL;
      }
      if (Number(qString.p) > 2) {
        const prevPage = Number(qString.p) - 1;
        currentURL = currentURL.replace(/p=\d+/, `p=${prevPage}`);
        return currentURL;
      }
    }
  };

  const getVendorsNextLink = () => {
    let currentURL = `${props.location.pathname.replace(
      trailingSlashRegex,
      ""
    )}${props.location.search}`;
    if (props.location.search) {
      const qString = queryString.parse(props.location.search);
      if (Number(qString.p) < Number(props.totalPages)) {
        const nextPage = Number(qString.p) + 1;
        currentURL = currentURL.replace(/p=\d+/, `p=${nextPage}`);
        return currentURL;
      }
    } else {
      if (props.currentPage === 1) {
        return `${currentURL}?p=1`;
      }
    }
  };

  const getVendorRefsPrevLink = (paginationInfo, loc) => {
    //if on first page then show nothing
    if (paginationInfo.current_page < 2) {
      return ``;
    } else {
      //if on other than first page then check
      if (!!loc.search) {
        let qParams = queryString.parse(loc.search);
        if (Number(qParams.p) === 2) {
          return (
            <link
              rel="prev"
              href={`${props.location.pathname.replace(
                trailingSlashRegex,
                ""
              )}`}
            />
          );
        } else {
          qParams.p = paginationInfo.current_page - 1;
          return (
            <link
              rel="prev"
              href={`${props.location.pathname.replace(
                trailingSlashRegex,
                ""
              )}?${queryString.stringify(qParams)}`}
            />
          );
        }
      } else {
        return (
          <link
            rel="prev"
            href={`${props.location.pathname.replace(
              trailingSlashRegex,
              ""
            )}?p=${paginationInfo.current_page - 1}`}
          />
        );
      }
    }
  };

  const getVendorRefsNextLink = (paginationInfo, loc) => {
    if (!!loc.search) {
      let qParams = queryString.parse(loc.search);
      if (Number(qParams.p) === paginationInfo.num_pages) {
        return ``;
      } else {
        qParams.p = paginationInfo.current_page + 1;
        return (
          <link
            rel="next"
            href={`${props.location.pathname.replace(
              trailingSlashRegex,
              ""
            )}?${queryString.stringify(qParams)}`}
          />
        );
      }
    } else if (paginationInfo.current_page === 1) {
      return (
        <link
          rel="next"
          href={`${props.location.pathname.replace(trailingSlashRegex, "")}?p=${
            paginationInfo.current_page + 1
          }`}
        />
      );
    }
    return ``;
  };

  const getCategoryNext = () => {
    const pathname = props.location.pathname.replace(trailingSlashRegex, "");
    if (props.currentPage < props.totalPages) {
      return `${pathname}?p=${props.currentPage + 1}`;
    }
  };

  const getCategoryPrev = () => {
    const pathname = props.location.pathname.replace(trailingSlashRegex, "");
    if (props.currentPage > 1) {
      return `${pathname}?p=${props.currentPage - 1}`;
    }
  };

  return (
    <React.Fragment>
      {props.location.pathname.includes("/vendors") && (
        <Helmet>
          <link rel="prev" href={getVendorsPrevLink()} />
          <link rel="next" href={getVendorsNextLink()} />
        </Helmet>
      )}
      {props.match.path.includes("/vendor/:id/case-studies") && (
        <Helmet>
          {getVendorRefsPrevLink(paginationInfo, props.location)}
          {getVendorRefsNextLink(paginationInfo, props.location)}
        </Helmet>
      )}
      {props.match.path.includes("/vendor/:id/testimonials") && (
        <Helmet>
          {getVendorRefsPrevLink(props.pagination, props.location)}
          {getVendorRefsNextLink(props.pagination, props.location)}
        </Helmet>
      )}
      {props.match.path.includes("/vendor/:id/customer-videos") && (
        <Helmet>
          {getVendorRefsPrevLink(props.pagination, props.location)}
          {getVendorRefsNextLink(props.pagination, props.location)}
        </Helmet>
      )}
      {props.match.path.includes("/software/:domain") && (
        <Helmet>
          <link rel="prev" href={getCategoryPrev()} />
          <link rel="next" href={getCategoryNext()} />
        </Helmet>
      )}
      {props.match.path.includes("/services/:domain") && (
        <Helmet>
          <link rel="prev" href={getCategoryPrev()} />
          <link rel="next" href={getCategoryNext()} />
        </Helmet>
      )}
      {props.location.pathname === "/press-releases" && (
        <Helmet>
          <link rel="prev" href={getCategoryPrev()} />
          <link rel="next" href={getCategoryNext()} />
        </Helmet>
      )}
    </React.Fragment>
  );
};

export default withRouter(CanonicalPagination);
